import React, { FC } from 'react'
import { BitazzaText } from '../../../../components'
import Style from './SeasonRunningStatus.module.scss'

interface Props {
    status?: string
    countDown?: number
    title: string
    description: string
}

export const SeasonRunningStatus: FC<Props> = ({
    status,
    countDown,
    title,
    description,
}) => {
    return (
        <div className={Style.container}>
            <BitazzaText
                content={title}
                letterSpacing={2}
                color="#fff"
                format="t18"
                bold
                display="block"
                textAlign="center"
            />
            <BitazzaText
                content={description}
                color="#86A1A1"
                format="t16"
                display="block"
                lineHeight={21}
                textAlign="center"
                letterSpacing={1}
            />
        </div>
    )
}
